import { FunctionComponent } from 'react'

import { Path, Svg } from 'react-native-svg'
import { resize } from 'src/utils'

type Props = { size?: number }

export const AlertIcon14: FunctionComponent<Props> = ({ size = 24 }) => {
  const { height, width } = resize({ height: 24, size, width: 24 })

  return (
    <Svg {...{ viewBox: '0 0 24 24', width, height }}>
      <Path
        fill="#73C177"
        fillRule="evenodd"
        d="M17.293 2H13.5a.5.5 0 0 0 0 1h3.793l-1.147 1.146a.5.5 0 0 0 .708.708l2-2A.506.506 0 0 0 19 2.5l-.001-.024a.487.487 0 0 0-.145-.33l-2-2a.501.501 0 0 0-.708.708L17.293 2Zm-7.796.996a.5.5 0 0 1 .5.5v1.55a7.551 7.551 0 0 1 1.538.374c.45.159.796.319.999.43a.499.499 0 1 1-.479.877 6.264 6.264 0 0 0-.853-.363c-.654-.23-1.321-.368-1.956-.368-1.345 0-2.308.598-2.308 1.362 0 .83.719 1.306 2.811 2.054l.196.07c2.412.861 3.28 1.415 3.28 2.738 0 1.49-1.251 2.346-3.228 2.483v1.521a.5.5 0 0 1-1 0v-1.512c-.845-.043-1.568-.213-2.174-.476-.44-.192-.735-.391-.895-.54a.5.5 0 1 1 .683-.73c.08.074.281.21.611.353.579.252 1.31.405 2.202.405 1.826 0 2.801-.57 2.801-1.504-.001-.679-.653-1.096-2.616-1.797l-.196-.07c-2.52-.9-3.475-1.531-3.475-2.995 0-1.377 1.349-2.275 3.059-2.355V3.496a.5.5 0 0 1 .5-.5ZM2.854 15.854a.5.5 0 0 0-.708-.708l-2 2a.506.506 0 0 0-.108.545.506.506 0 0 0 .108.163l2 2a.501.501 0 0 0 .708-.708L1.707 18H5.5a.5.5 0 0 0 0-1H1.707l1.147-1.146Z"
        clipRule="evenodd"
      />
    </Svg>
  )
}
